module.exports = __webpack_public_path__ + "img/banner16.5f1144e0.png";